import { render, staticRenderFns } from "./SubcategoryPage.vue?vue&type=template&id=ebb98426&scoped=true"
import script from "./SubcategoryPage.vue?vue&type=script&lang=js"
export * from "./SubcategoryPage.vue?vue&type=script&lang=js"
import style0 from "./SubcategoryPage.vue?vue&type=style&index=0&id=ebb98426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb98426",
  null
  
)

export default component.exports